import styled from "styled-components";
export const ErrorLabel = styled.span `
  display: block;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fontTokens.font14[0]};
  line-height: ${({ theme }) => theme.fontTokens.font14[0]};

  ${({ alignByContent }) => {
    const transaltionValue = 8;
    return alignByContent === "left"
        ? `transform: translate(-${transaltionValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${transaltionValue}px);`
            : "";
}}

  @media ${({ theme }) => theme.device.touch} {
    margin-top: 0.625rem;
    margin-left: 0.625rem;
    ${({ alignByContent }) => {
    const transaltionValue = 10;
    return alignByContent === "left"
        ? `transform: translate(-${transaltionValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${transaltionValue}px);`
            : "";
}}
  }
`;
